module.exports = __webpack_public_path__ + "static/media/bubble-1.92543381.png";